import { FileText } from "lucide-react";

import { contextValue, taskInfo } from "pages/CaseDetail/taskKinds";
import { CaseTask } from "pages/CaseDetail/types";

interface DocumentLink {
  label: string;
  url: string;
}

const TaskInfo = ({ task }: { task: CaseTask }) => {
  const paragraphs = taskInfo(task);
  const documents = (contextValue(task, "documents") ?? []) as DocumentLink[];

  return (
    <div className="space-y-3 rounded-md bg-muted/50 p-4 text-brand-copy-primary">
      {paragraphs.length > 0 ? (
        paragraphs.map((text) => (
          <p key={text} className="whitespace-pre-line">
            {text}
          </p>
        ))
      ) : (
        <p className="text-muted-foreground">No further details.</p>
      )}
      {documents.length > 0 && (
        <ul className="flex flex-wrap gap-x-4 gap-y-1">
          {documents.map((document) => (
            <li key={document.url}>
              <a
                href={document.url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 hover:underline"
              >
                <FileText className="size-4" aria-hidden="true" />
                {document.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TaskInfo;
